module.exports = __webpack_public_path__ + "img/story_pro.0ea48078.jpg";